import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { SectionLabel } from './SectionLabel';
export function ProjectQuestions() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="questions-heading" className="w-full border-y border-warm-200 bg-white py-20 lg:py-24" data-id="element-177" data-mp="h7uq7162unil">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-178" data-mp="3lnm2az3agrgo">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-179" data-mp="3lmaveqejr3lc">
          <div className="lg:col-span-4" data-id="element-180" data-mp="3gqvokieyi7yf">
            <SectionLabel number="05" data-id="element-181" data-mp="3uggyl3as3cub">Project questions</SectionLabel>
            <h2 id="questions-heading" className="mt-5 font-display text-[30px] font-semibold uppercase leading-[1.05] text-ink sm:text-[38px]" data-id="element-182" data-mp="3uitp44ulqviz">
              Useful answers before you call.
            </h2>
          </div>

          <div className="lg:col-span-8" data-id="element-183" data-mp="2xxrnibzessts">
            <ul className="border-t border-ink" data-id="element-184" data-mp="2xx05k3yqitlz">
              {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return <li key={faq.question} className="border-b border-warm-200" data-id="element-185" data-mp="vngt394jpdca" data-mpi={index}>
                    <h3 data-id="element-186" data-mp="10gt42ggaxlmk">
                      <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} id={`faq-button-${index}`} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex min-h-[60px] w-full items-center justify-between gap-6 py-4 text-left font-display text-[21px] uppercase leading-tight text-ink transition-colors duration-150 ease-industrial hover:text-steel" data-id="element-187" data-mp="10gjn1id8iot0">
                        <span data-id="element-188" data-mp="1t58eepohnfrk">{faq.question}</span>
                        {isOpen ? <MinusIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-safety-600" data-id="element-189" data-mp="1y30hmful2ob2" /> : <PlusIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-safety-600" data-id="element-190" data-mp="3u5dgktje7mz1" />}
                      </button>
                    </h3>
                    <div id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-button-${index}`} hidden={!isOpen} className="pb-6 pr-8" data-id="element-191" data-mp="70xi0581v5n2">
                      <p className="max-w-2xl text-base leading-relaxed text-steel" data-id="element-192" data-mp="36hc6hg6kfyhi">{faq.answer}</p>
                    </div>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}